/**
 * SHA-256 (hex) of a verification document body exactly as stored, or of ''
 * when there is none. Must match the API's verificationFingerprint, which uses
 * it to reject saves made from a copy that is no longer current.
 */
export async function verificationFingerprint(body: string | null | undefined): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(body ?? ''));
  return [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}
